export default {
  title: 'Preț nou',
  fields: {
    product: {
      label: 'Produs',
    },
    is_not_personal: {
      label: 'Vizibil pentru toți',
    },
    is_default: {
      label: 'Implicit',
    },
    visible_to: {
      label: 'Vizibil pentru',
    },
  },
  buttons: {
    select_all: 'Selectați toate',
    save: 'Salvați',
    cancel: 'Anulați',
  },
  feedback: {
    missing_info: 'Informații lipsă',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    price_got_created: 'Prețul a fost creat',
    price_got_updated: 'Prețul a fost actualizat',
  },
};
